import * as types from './mutation-types'

export default {
  [types.ADD_BOXES](state, data) {
    state.boxes = data.boxes
  },
  [types.ADD_BOXE](state, data) {
    state.boxes.push(data)
  },
}
